import * as TWEEN from "@tweenjs/tween.js";

/**
 * class: TweenBase
 */
export class TweenBase {
    private _instance: TWEEN.Tween;
    public get me(): TWEEN.Tween { return this._instance; }
    public set me(i: TWEEN.Tween) { this._instance = i; }

    private _from: {};
    private _to: {};
    private _delay: number;
    private _easing: any;
    private _duration: number;
    private _completion: string;

    constructor(from?: {}, to?: {}) {
        this._from = (from == undefined) ? {} : from;
        this._to = (to == undefined) ? {} : to;
        this._delay = 0;
        this._duration = 1000;
        this._easing = TWEEN.Easing.Sinusoidal.InOut;
        this._completion = '';
    }
    public get from(): {} { return this._from; }
    public set from(val: {}) { this._from = val; }
    public set to(val: {}) { this._to = val; }
    public set delay(val: number) { this._delay = val; }
    public set duration(val: number) { this._duration = val; }
    public set easing(val: any) { this._easing = val; }

    public prepare(): TWEEN.Tween {
        if (this.me == undefined) { this._instance = new TWEEN.Tween(this._from); }
        this.me.delay(this._delay);
        this.me.to(this._to, this._duration);
        this.me.easing(this._easing);
        return this.me;
    } // to override.

    public start() { this.me.start(); }
}

/**
 * class: TweenChainBase
 */
export class TweenChainBase {
    private _tweens: TweenBase[];
    constructor() { this._tweens = []; }
    public add(tween: TweenBase) {
        if (this._tweens.length > 0) this._tweens[this._tweens.length - 1].me.chain(tween.me);
        this._tweens.push(tween);
    }
    public start() { if (this._tweens.length > 0) this._tweens[0].start(); }
}
